module.exports = __webpack_public_path__ + "img/bond-process.5c848bee.png";